import React, { useState, useEffect } from "react";
import axios from "axios";

const ApiTest = () => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/test`
        );
        setData(response.data);
      } catch (err) {
        setError("Error al conectar con la API");
        console.error(err);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h1>Prueba de Conexión a la API</h1>
      {error && <p style={{ color: "red" }}>{error}</p>}
      {data ? (
        <pre>{JSON.stringify(data, null, 2)}</pre>
      ) : (
        <p>Cargando datos...</p>
      )}
    </div>
  );
};

export default ApiTest;
